/**
 *
 * Multi Select Field
 *
 */

import React from "react"
import PropTypes from "prop-types"
import { Label, FormGroup } from "reactstrap"
import Select from "react-select"

function MultiSelectField(props) {
  const {
    label,
    name,
    value,
    onChange,
    isInvalid,
    metaData,
    required,
    options = [],
  } = props
  const selectOptions =
    options && Array.isArray(options)
      ? options
      : typeof options === "string" &&
        metaData &&
        metaData[options] &&
        metaData[options].length > 0
      ? metaData[options]
      : []
  // const menuPortalTarget = document.getElementById("root")

  const customStyles = {
    menu: (base) => ({
      ...base,
      opacity: 2,
      position: "absolute",
      zIndex: 9999,
    }),
  }
  return (
    <React.Fragment>
      <FormGroup className="no-margin">
        <Label htmlFor="formrow-firstname-Input">
          {label}
          {required ? (
            <span style={{ color: "red", marginLeft: "3px" }}>*</span>
          ) : null}
        </Label>
        <Select
          name={name}
          value={
            selectOptions && selectOptions.length > 0 && value
              ? selectOptions.filter((_) => value.includes(_.value))
              : false
          }
          onChange={(val) => onChange({ value: val.map((_) => _.value) })}
          options={selectOptions}
          maxMenuHeight={220}
          className={isInvalid ? "" : null}
          classNamePrefix="select2-selection"
          invalid={isInvalid ? true : false}
          isMulti={true}
          styles={customStyles}
          // menuPortalTarget={menuPortalTarget}
        />
      </FormGroup>
    </React.Fragment>
  )
}

MultiSelectField.propTypes = {
  t: PropTypes.any,
  label: PropTypes.string,
  value: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  isInvalid: PropTypes.any,
  metaData: PropTypes.object,
  options: PropTypes.any,
  required: PropTypes.any,
}

export default MultiSelectField
